'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;
exports.isValidEmail = isValidEmail;
exports.saveEmail = saveEmail;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_VALID = 'nenudimse/leaveUsMailForm/IS_VALID';
var IS_VALID_SUCCESS = 'nenudimse/leaveUsMailForm/IS_VALID_SUCCESS';
var IS_VALID_FAIL = 'nenudimse/leaveUsMailForm/IS_VALID_FAIL';
var SAVE = 'nenudimse/leaveUsMailForm/SAVE';
var SAVE_SUCCESS = 'nenudimse/leaveUsMailForm/SAVE_SUCCESS';
var SAVE_FAIL = 'nenudimse/leaveUsMailForm/SAVE_FAIL';

var initialState = {
  saveError: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var data = void 0;

  switch (action.type) {
    case IS_VALID:
      return state; // 'saving' flag handled by redux-form
    case IS_VALID_SUCCESS:
      data = [].concat((0, _toConsumableArray3.default)(state.data));
      data[action.result.id - 1] = action.result;
      return (0, _extends3.default)({}, state, {
        data: data,
        saveError: null
      });
    case IS_VALID_FAIL:
      return typeof action.error === 'string' ? (0, _extends3.default)({}, state, {
        saveError: action.error
      }) : state;
    case SAVE:
      return state; // 'saving' flag handled by redux-form
    case SAVE_SUCCESS:
      data = [].concat((0, _toConsumableArray3.default)(state.data));
      data[action.result.id - 1] = action.result;
      return (0, _extends3.default)({}, state, {
        data: data,
        saveError: null
      });
    case SAVE_FAIL:
      return typeof action.error === 'string' ? (0, _extends3.default)({}, state, {
        saveError: action.error
      }) : state;
    default:
      return state;
  }
}

function isValidEmail(data) {
  return {
    types: [IS_VALID, IS_VALID_SUCCESS, IS_VALID_FAIL],
    promise: function promise(client) {
      return client.post('/leaveUsMailForm/isValid', {
        data: data
      });
    }
  };
}

function saveEmail(data) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.post('/leaveUsMailForm/saveEmail', {
        data: data
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/leaveUsMailForm.js
// module id = 1123
// module chunks = 0